export default __webpack_public_path__ + "static/media/qualification-service.43972bd9.png";